import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageWithHeader, Navigation } from 'modules/ui';
import { NavigationType } from 'modules/ui/navigation';
import { getProfilePageTabs } from './getTabs';
import {
  PageContent,
  StyledComponentFlex,
  StyledNavigationFlex,
} from './styled';
import { ProfilePageKeys, getProfilePageUrl } from './helper';

export interface ProfilePageLayoutProps {
  tab: string;
}

export const ProfilePageLayout: FC<ProfilePageLayoutProps> = ({ tab }) => {
  const { t } = useTranslation();

  const ActiveTabForm = useMemo(
    () => getProfilePageTabs(t).find((tabForm) => tabForm.key === tab),
    [tab, t],
  );

  return (
    <PageWithHeader
      title={t('profilePage.title')}
      breadcrumbs={[
        { text: t('profilePage.breadcrumbs.home'), url: '/' },
        { text: t('profilePage.breadcrumbs.editProfile'), url: '' },
      ]}>
      <PageContent>
        <StyledNavigationFlex>
          <Navigation
            type={NavigationType.Sidebar}
            activeTab={tab}
            options={[
              {
                label: t('profilePage.navigation.informationOverview'),
                url: getProfilePageUrl(ProfilePageKeys.Information),
              },
              {
                label: t('profilePage.navigation.dataModification'),
                url: getProfilePageUrl(ProfilePageKeys.DataModification),
              },
              // FRON-531 Commented other tabs for release day
              // {
              //   label: t('profilePage.navigation.passwordReset'),
              //   url: getProfilePageUrl(ProfilePageKeys.PasswordReset),
              // },
              {
                label: t('profilePage.navigation.contactPerson'),
                url: getProfilePageUrl(ProfilePageKeys.ContactPerson),
              },
            ]}
            title={t('navigation.menu')}
          />
        </StyledNavigationFlex>
        <StyledComponentFlex>{ActiveTabForm?.component}</StyledComponentFlex>
      </PageContent>
    </PageWithHeader>
  );
};
